<template>
  <detailed-view-container
    questionnaireTitle="PHQ"
    :questionnaire="questionnaire"
  >
    <template v-slot:questionnnairePanel>
      <PHQQuestionnairePanels :questionnaire="questionnaire" />
    </template>
  </detailed-view-container>
</template>

<script>
const components = {
  PHQQuestionnairePanels: () =>
    import(
      "@/components/views/dashboard/members/id/partial/questionnaires/components/PHQQuestionnairePanels.vue"
    ),
  DetailedViewContainer: () =>
    import(
      "@/components/views/dashboard/members/id/partial/questionnaires/DetailedViewContainer.vue"
    ),
};

export default {
  name: "PHQ",

  props: {
    questionnaire: {
      type: Object,
      default: () => {},
    },
  },

  components,
};
</script>